import { useState } from 'react';

const faqs = [
  {
    q: '歪歪漫画网需要注册才能使用吗？',
    a: '不需要。歪歪漫画网所有漫画资源均支持免费在线阅读，无需注册登录、无需付费订阅，打开歪歪漫画网站入口即可直接畅看全部内容。',
  },
  {
    q: '什么是下拉式全集阅读模式？',
    a: '下拉式阅读是一种纵向连续浏览方式，您在阅读漫画时只需向下滑动屏幕，系统会自动加载下一话内容，无需手动翻页或点击"下一话"按钮，实现沉浸式无缝阅读体验。',
  },
  {
    q: '歪歪漫画网的漫画多久更新一次？',
    a: '我们的编辑团队每日追踪日韩热门漫画连载动态，与官方保持同步更新节奏。热门连载作品通常每周更新一到两话，部分高人气作品可实现日更。',
  },
  {
    q: '网站支持哪些类型的漫画作品？',
    a: '歪歪漫画网聚合了丰富的日漫在线阅读、好看的韩漫以及国漫大全资源，涵盖热血战斗、恋爱甜宠、奇幻冒险、悬疑推理、搞笑日常、耽美百合等多种题材，满足各类读者的喜好。',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (i: number) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">常见问题</h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">关于歪歪漫画网的使用与功能，这里有您想了解的答案</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-lg border border-background-200/70 overflow-hidden cursor-pointer"
              onClick={() => toggle(i)}
            >
              <div className="flex items-center justify-between px-5 py-4">
                <h3 className="text-base md:text-lg font-heading font-bold text-foreground-900 pr-4">{faq.q}</h3>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-foreground-500 text-lg"></i>
                </div>
              </div>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === i ? 'max-h-96 pb-4' : 'max-h-0'
                }`}
              >
                <p className="px-5 text-sm md:text-base text-foreground-600 leading-relaxed">{faq.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}